import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Icon from 'components/shared/Icon';
import Text from 'components/shared/layouts/Text';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledContainer = styled(forwardRef(({ selected, color, ...props }, ref) => <div ref={ref} {...props} />))`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
  padding-top: ${theme.spaces.smallX}px;
  padding-bottom: ${theme.spaces.smallX}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;

  ${({ selected }) =>
    selected &&
    css`
      background: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
    `}

  ${({ selected, color }) =>
    selected &&
    color &&
    css`
      background: ${hexToRGBA(color, 0.08)};
    `}

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.smallX - 2}px;
    padding-bottom: ${theme.spaces.smallX - 2}px;
    padding-left: ${theme.spaces.smallX}px;
    padding-right: ${theme.spaces.smallX}px;
    gap: ${theme.spaces.small2X}px;
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Tab = ({ tabId, iconAlias, title, selected, color, onSelect }) => {
  const handleSelect = () => {
    onSelect && onSelect(tabId);
  };

  return (
    <StyledContainer color={color} selected={selected === tabId} onClick={handleSelect}>
      <StyledIconContainer>
        <Icon alias={iconAlias} color={color || theme.colors.gray.secondary} height={20} width={20} />
      </StyledIconContainer>
      <Text
        size={theme.fontSizes.small}
        weight={500}
        lineHeight={theme.spaces.large}
        color={color || theme.colors.gray.secondary}
        desktop
      >
        {title}
      </Text>
      <Text
        size={theme.fontSizes.smallX}
        weight={500}
        lineHeight={theme.spaces.regular}
        color={color || theme.colors.gray.secondary}
        mobile
      >
        {title}
      </Text>
    </StyledContainer>
  );
};

Tab.propTypes = {
  tabId: PropTypes.string,
  iconAlias: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.string,
  color: PropTypes.string,
  onSelect: PropTypes.func,
};

export default Tab;
